import {
  Avatar,
  Box,
  Button,
  Card,
  CircularProgress,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography
} from '@mui/material';
import React from 'react';
import Scrollbar from 'src/components/Scrollbar';
import { UserListHead } from '../user';
import SearchNotFound from 'src/components/SearchNotFound';

function EarningsDetailModal({ handleClose, earningdetail, loading }) {
  const tableRef = React.createRef();
  const TABLE_HEAD = [
    { id: 'order no', label: 'Order No', alignRight: false },
    { id: 'noi', label: 'No of Items', alignRight: false },
    { id: 'item_earning', label: 'Item Earning', alignRight: false },
    { id: 'delivery_fee', label: 'Delivery Fee', alignRight: false },
    { id: 'protection_fee', label: 'Protection Fee', alignRight: false },
    { id: 'total_earning', label: 'Total Earning', alignRight: false }
  ];
  const isDataFound = earningdetail.length === 0;
  return (
    <Box>
      <Card>
        <TableContainer sx={{ minWidth: 800 }}>
          <Scrollbar>
            <Table ref={tableRef}>
              <UserListHead headLabel={TABLE_HEAD} rowCount={TABLE_HEAD.length} />
              <TableBody>
                {earningdetail &&
                  earningdetail.map((row) => {
                    console.log('row of earning detail', row);
                    const {
                      id,
                      order_no,
                      item_count,
                      delivery_fee,
                      total_item_sum,
                      total_vint_earning_sum,
                      order_total_sum
                    } = row;
                    return (
                      <TableRow key={id}>
                        {/* ORDER NO */}
                        <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2">
                            {order_no || 'N/A'}
                          </Typography>
                        </TableCell>
                        {/* NO OF ITEMS */}
                        <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2">
                            {item_count || 'N/A'}
                          </Typography>
                        </TableCell>

                        {/* SELLER EARNINGS */}
                        <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2">
                            {total_item_sum || 'N/A'}
                          </Typography>
                        </TableCell>
                        {/* Delevery FEE */}
                        <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2">
                            {delivery_fee || 'N/A'}
                          </Typography>
                        </TableCell>
                        {/* PROTECTION FEE */}
                        <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2">
                            {total_vint_earning_sum || 'N/A'}
                          </Typography>
                        </TableCell>
                        {/* total earning */}
                        <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2">
                            {order_total_sum}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
              {isDataFound && !loading && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={12} sx={{ py: 3 }}>
                      <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
                        data not found
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
            {loading && (
              <Box
                py={5}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  flex: 1
                }}
              >
                <CircularProgress />
              </Box>
            )}
          </Scrollbar>
        </TableContainer>
      </Card>
      <Box
        style={{
          justifyContent: 'flex-end',
          display: 'flex',
          marginTop: 30
        }}
      >
        <Button color="primary" variant="contained" onClick={handleClose} size={'small'}>
          Close
        </Button>
      </Box>
    </Box>
  );
}

export default EarningsDetailModal;
